export default {
  'message.error-message.title': 'Er is iets fout gegaan',
  'message.success-message.title': 'Geslaagd!',
};
